<template>
  <icon-text-button
    :icon="icon"
    :outlined="outlined"
    :active="active"
    @click="$emit('click')">
    <slot />
  </icon-text-button>
</template>

<script>
import IconTextButton from '@/components/parts/IconTextButton'

const iconType = {
  attend: 'circle',
  absence: 'close'
}
export default {
  components: {
    IconTextButton
  },
  props: {
    // attend | absence
    type: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      default: 0
    },
    active: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    icon() {
      return iconType[this.type]
    },
    outlined() {
      return this.type === 'attend'
    }
  }
}
</script>

<style>

</style>